import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { IMainstreetEvent } from '../classes';
import { calendarDispatch } from '../calendar'
import { setLocationFilter } from '../actions';

interface ICalendarFiltersLocation {
    selectedLocationFilter: string;
}

class CalendarFiltersLocation extends React.Component<ICalendarFiltersLocation, any>{
    locationList: Array<any>;

    constructor(props) {
        super(props);
        this.locationList = (window as any).filterOptions.location;
    }

    render() {
        return (
            <div className="calendar-filter-location">
                <label>By Location</label>
                <div>
                    {
                        this.locationList.map((location) => <div key={location}>
                            <input name="location" type="radio" id={location} checked={this.props.selectedLocationFilter === location} value={location} onChange={this.sendAction.bind(this)} />
                            <label htmlFor={location}>
                                <span>
                                    <div className="calendar-icon-radio-unselected">
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-radio-unselected" />
                                        </svg>
                                        <span className="text">
                                            <span className="visually-hidden">Radio button unselected</span>
                                        </span>
                                    </div>
                                    <div className="calendar-icon-radio-selected">
                                        <svg className="svg-icon" aria-hidden="true" focusable="false">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-radio-selected" />
                                        </svg>
                                        <span className="text">
                                            <span className="visually-hidden">Radio button selected</span>
                                        </span>
                                    </div>
                                </span>
                            {location}</label>
                        </div>)
                        //this.locationList.map((location) => <div key={location}><input name="location" type="radio" checked={this.props.selectedLocationFilter === location} value={location} onChange={this.sendAction.bind(this)} />{location}</div>)
                    }
                </div>
            </div >
        )
    }
    sendAction(e) {
        console.log(e.target.value);
        calendarDispatch()(setLocationFilter(e.target.value));

    }
};

export default CalendarFiltersLocation;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/filters/calendar-filters-location.tsx